module.exports = "/_next/static/images/e94156d42a8a5142e197fb906be9dcaf-debit-card-cut-xs.png.webp";